// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const config: Config = {
  browserChannelURL:
    window["env"]["browserChannelURL"] ||
    "wss://browser-channel.ehs.sandbox.entersekt.com?auth=something",
};

interface Config {
  browserChannelURL: string;
}
